var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvgLogoHorizontalWhiteVersionWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 141.7",
    style: {
      enableBackground: "new 0 0 841.9 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 841.9,
    height: 141.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "IVECO_GROUP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.6,50.2h6v41.6h-6V50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.5,50.2h6l-17.7,41.6h-1.4l-18-41.6h6L132,79.3L144.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.4,49.6c6-0.2,11.8,2,16.1,6.1c4.2,3.9,6.6,9.5,6.4,15.2c0.1,5.8-2.2,11.3-6.5,15.2c-4.3,4-9.8,6-16.4,6 c-5.8,0.2-11.5-2-15.7-6c-4.1-3.9-6.4-9.4-6.3-15.1c-0.2-5.8,2.1-11.4,6.3-15.4C336.6,51.6,342,49.6,348.4,49.6z M348.7,55.2 c-4.4-0.2-8.6,1.4-11.8,4.5c-3.1,3-4.8,7.1-4.6,11.4c-0.1,4.2,1.6,8.3,4.6,11.2c6.6,6,16.7,5.9,23.3-0.1c3.1-2.9,4.8-7.1,4.7-11.3 c0.1-4.2-1.6-8.2-4.7-11.1C357.1,56.8,352.9,55.1,348.7,55.2L348.7,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.9,49.6c6-0.2,11.8,2,16.1,6.1c4.2,3.9,6.6,9.5,6.4,15.3c0.2,5.8-2.2,11.3-6.4,15.2c-4.3,4-9.8,6-16.4,6 c-5.8,0.2-11.5-2-15.7-6c-4.1-3.9-6.4-9.4-6.3-15.1c-0.2-5.8,2.1-11.4,6.3-15.4C611.1,51.6,616.4,49.6,622.9,49.6z M623.1,55.2 c-4.4-0.2-8.6,1.4-11.8,4.5c-3.1,3-4.8,7.1-4.6,11.4c-0.1,4.2,1.6,8.3,4.6,11.2c6.6,6,16.7,5.9,23.3-0.1c3.1-2.9,4.8-7,4.7-11.3 c0.1-4.2-1.6-8.2-4.7-11.1C631.5,56.8,627.4,55.1,623.1,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M706.6,50.2h6v23.5c0.1,2.4-0.2,4.8-0.7,7.2c-0.4,1.4-1,2.8-1.7,4c-0.7,1.1-1.5,2.1-2.5,2.9 c-3.3,2.8-7.7,4.2-13,4.2c-5.5,0-9.8-1.4-13.1-4.2c-1-0.8-1.8-1.8-2.5-2.9c-0.8-1.2-1.3-2.6-1.7-4c-0.5-2.4-0.8-4.9-0.7-7.4V50.2h6 v23.5c0,3.9,0.4,6.6,1.3,8.1c1,1.6,2.4,2.9,4.1,3.7c2,1,4.3,1.4,6.5,1.4c3.1,0.1,6.2-0.8,8.7-2.8c1.1-0.9,2-2.1,2.5-3.5 c0.6-2.2,0.9-4.6,0.8-6.9L706.6,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747,91.8V50.1h15.1c4,0,7.2,1.1,9.5,3.2c2.4,2.2,3.7,5.3,3.6,8.6c0,2.3-0.6,4.5-1.8,6.4c-1.2,1.8-3,3.2-5,4 c-2.9,1-6,1.4-9.1,1.3H753v18.2H747z M761.1,55.4h-8.1v13h8.4c2,0.1,4-0.5,5.6-1.7c1.4-1.2,2.1-3,2-4.9 C769.1,57.6,766.4,55.4,761.1,55.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 418.3,
    cy: 74.6,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.7,91.8l-13.1-20.6c1.5-0.8,2.8-1.9,3.7-3.3c1.2-1.8,1.9-4,1.8-6.3c0.1-3.2-1.2-6.3-3.7-8.4 c-2.5-2.1-5.8-3.1-10.1-3.1h-11.6v41.6h6V55.2h1.8c2.5-0.1,5,0.1,7.5,0.7c1.2,0.4,2.3,1.2,3,2.2c0.7,1.1,1,2.3,1,3.5 c0,1.2-0.3,2.5-1,3.5c-0.6,1-1.5,1.8-2.6,2.3c-1.3,0.5-2.7,0.7-4.1,0.7l15,23.5H573.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.2,71.2h11.4v17.6c-4.8,2.2-10,3.3-15.3,3.3c-6.9,0-12.4-2-16.6-6c-4.1-3.8-6.3-9.2-6.2-14.8 c-0.1-5.8,2.2-11.5,6.4-15.5c4.3-4.1,10.1-6.4,16.1-6.2c2.3,0,4.5,0.2,6.7,0.8c2.7,0.7,5.4,1.7,8,2.8v6c-4.5-2.7-9.6-4.1-14.8-4.2 c-4.3-0.1-8.5,1.6-11.5,4.6c-3.1,3-4.8,7.1-4.7,11.4c-0.2,4.3,1.6,8.5,4.7,11.5c3.3,3,7.6,4.6,12.1,4.5c2.9-0.1,5.8-0.6,8.6-1.6 l0.6-0.2v-8.7h-8.8L492.2,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,82.4c-4.3,2.7-9.2,4.2-14.3,4.3c-4.4,0.2-8.7-1.4-11.9-4.4c-3.1-2.9-4.8-7-4.7-11.2 c-0.1-4.3,1.6-8.4,4.8-11.3c3.2-3,7.5-4.6,11.9-4.5c5,0.1,9.9,1.5,14.2,4.1V53c-4.6-2.1-9.5-3.2-14.5-3.4c-6-0.2-11.7,2.1-16,6.2 c-4.3,3.9-6.6,9.4-6.5,15.2c0,7.5,4,14.5,10.6,18.3c3.6,2,7.7,2.9,11.9,2.8c5.1,0.1,10.1-1,14.7-3.3L290.4,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.6,50.2h26.4l-3.4,5.3h-17.1v12.9h17v5.3h-17v12.9h19.9v5.3h-25.9V50.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvgLogoHorizontalWhiteVersionWeb);
export default __webpack_public_path__ + "static/media/IVG_Logo_Horizontal_White_Version_Web.ba706e369451aba6ce4d688b8550e5a0.svg";
export { ForwardRef as ReactComponent };